/**
 * API des méthodes de paiement.
 * Utilise le client HTTP existant (auth Bearer + baseURL).
 * GET /payment-methods, GET /payment-methods/:id, PUT /payment-methods/:id
 */

import httpService from "../services/http.service";

/**
 * Liste des méthodes de paiement.
 * @returns {Promise<{ success: boolean, message: string, data: import('../types/payment').PaymentMethodSummary[] }>}
 */
export function fetchPaymentMethods() {
  return httpService.get("/payment-methods").then((res) => res.data);
}

/**
 * Détail d'une méthode (pays, fees, channels, provider_payment_channels).
 * @param {string|number} id
 * @returns {Promise<{ success: boolean, message: string, data: import('../types/payment').PaymentMethodDetail }>}
 */
export function fetchPaymentMethodById(id) {
  return httpService.get(`/payment-methods/${id}`).then((res) => res.data);
}

/**
 * Mise à jour partielle. Seuls les champs envoyés sont mis à jour (spec 8.1).
 * @param {string|number} id
 * @param {import('../types/payment').UpdatePaymentMethodPayload} payload
 * @returns {Promise<{ success: boolean, message: string, data?: unknown }>}
 */
export function updatePaymentMethod(id, payload) {
  return httpService.put(`/payment-methods/${id}`, payload).then((res) => res.data);
}

/**
 * Supprime une méthode de paiement (refus si wallets encore liés).
 * @param {string|number} id method_id
 */
export function deletePaymentMethod(id) {
  return httpService.delete(`/payment-methods/${id}`).then((res) => res.data);
}
